import {BsEraserFill} from "react-icons/bs";
import {useNavigate, useParams} from "react-router-dom";

import {SectionLabel} from "../../common/SectionLabel";

// Н6 — обобщаващият ред. Колоните станаха четири: „Други" се раздели на
// „Други(+)" (увеличава правното) и „Други(−)" (намалява го).
//
// Бутонът „Редакция" тук се водеше „не работи". Причината НЕ беше навигацията:
// той навигира вярно и формата се отваря. Но ако формата ВЕЧЕ е отворена и
// човекът се е върнал горе, вторият клик е навигация към същия маршрут —
// нищо не се сменя, компонентът не се монтира наново и превъртането (което
// живее в неговия `useEffect`) не се изпълнява. Тоест: кликаш и не става нищо,
// завинаги. Затова тук се превърта ИЗРИЧНО, независимо дали маршрутът се смени.
export const OthersInfo = ({othersInfo}) => {
    const navigate = useNavigate();
    const {year, settlement_ekatte, bullstat} = useParams();

    // Н6: нулата е СМИСЛЕН запис, не липсваща стойност. „Записах нула" е
    // нормално действие (то е и това, което гаси предупредителния знак на таба
    // „БП и пътища"), затова 0 се показва като 0.00, а „неопределено" остава
    // само за наистина непопълнено поле. Старият вид (`v ? … : "неопределено"`)
    // показваше нулата като непопълнена и човек не можеше да различи двете.
    const fmt = (v) => (v === null || v === undefined || v === ''
        ? "неопределено" : Number(v).toFixed(2));

    const openForm = () => {
        navigate(`/info/${year}/${settlement_ekatte}/${bullstat}/other`);
        // Двойно превъртане нарочно: ако формата се монтира сега, нейният
        // собствен effect ще уточни мястото; ако вече е била отворена, това тук
        // е единственото, което ще се случи.
        requestAnimationFrame(() => {
            document.getElementById('company-forms')
                ?.scrollIntoView({behavior: "smooth", block: "center"});
        });
    };

    return (
        <>
            <SectionLabel width="75%">Други площи</SectionLabel>
            <div className="d-flex justify-content-center">
                <table className="table w-75">
                    <thead>
                    <tr>
                        <th className="text-center" scope="col">Пътища</th>
                        <th className="text-center" scope="col">Бели петна</th>
                        <th className="text-center" scope="col">Други(+)</th>
                        <th className="text-center" scope="col">Други(−)</th>
                        <th className="text-center" scope="col"></th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr>
                        <td className="text-center" style={{paddingTop: "14px"}}>{fmt(othersInfo.roads)}</td>
                        <td className="text-center" style={{paddingTop: "14px"}}>{fmt(othersInfo.white_spots)}</td>
                        <td className="text-center" style={{paddingTop: "14px"}}>{fmt(othersInfo.others_plus)}</td>
                        <td className="text-center" style={{paddingTop: "14px"}}>{fmt(othersInfo.others)}</td>
                        <td className="text-center">
                            <button
                                onClick={openForm}
                                data-bs-toggle="tooltip"
                                title="Редакция на другите площи"
                                type="button"
                                className="btn btn-warning">
                                <BsEraserFill/>
                            </button>
                        </td>
                    </tr>
                    </tbody>
                </table>
            </div>
        </>
    );
};
